export const WhatsappCode = () => {
    return (
        <div className="modal fade " id="whatsapp" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content bg-color">
                    <div className="modal-header">
                        <h5 className="modal-title " id="staticBackdropLabel">Scan Whatsapp Code</h5>
                    </div>
                    <div className="modal-body">
                    <img className="img-fluid" src="./qr-code.jpg" alt="whatsapp-qr-code" />
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export const GmailId = () => {
    return (
        <div className="modal fade " id="gmail" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content bg-color">
                    <div className="modal-header">
                        <h5 className="modal-title " id="staticBackdropLabel">My Email Id</h5>
                    </div>
                    <div className="modal-body overflow-hidden">
                    <p className="fs-4 text-center">mohitsehrawat000@gmail.com</p>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    );
};